export default __webpack_public_path__ + "static/media/tool1.63f7bfa6.png";